import { Grid } from '@material-ui/core';
import { Button, Card, Dialog, Typography } from '@nutrien/cxp-components';
import { observer } from 'mobx-react-lite';
import React from 'react';

import type { PreviousReportFiles } from '../../rxdb/previousReports/previousReports.types';
import PreviousReportDetails from '../PreviousReportDetails';
import useStyles from './PreviousReports.styles';

interface Props {
  open: boolean;
  onClose: () => void;
  reports: PreviousReportFiles[];
}

const PreviousReports: React.FC<Props> = ({ open, onClose, reports }) => {
  const classes = useStyles();

  return (
    <>
      <Dialog
        onClose={onClose}
        fullScreen
        open={open}
        titleText={`Previous Reports (${reports?.length})`}
        backButton={false}
        dialogActions={
          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            className={classes.closeBtn}
          >
            <Grid item>
              <Button
                noMinHeight
                color="primary"
                variant="contained"
                onClick={onClose}
                data-testid="close-previous-report"
              >
                Close
              </Button>
            </Grid>
          </Grid>
        }
        maxWidth="xs"
        noMinHeight
      >
        {reports && reports?.length > 0 ? (
          <Card elevation={1} className={classes.card}>
            {reports?.map(report => (
              <PreviousReportDetails report={report} key={report.pkAssetInspection} />
            ))}
          </Card>
        ) : (
          <>
            <Typography className={classes.fileMessage}>
              No previous reports are there for this inspection
            </Typography>
          </>
        )}
      </Dialog>
    </>
  );
};
export default observer(PreviousReports);
